import React, { useMemo } from "react";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import FilterMenu from "../common/FilterMenu";

export default function FiltersBar({ locations, filters, setFilters, onDownload }) {
  const statusOptions = [
    { id: 'ok', label: 'Online' },
    { id: 'offline', label: 'Offline' },
    { id: 'no-data', label: 'No Data' }
  ];
  
  const cityOptions = useMemo(
    () => Array.from(new Set(locations.map((n) => n.city).filter(Boolean))).map(city => ({
      id: city,
      label: city
    })),
    [locations]
  );
  
  const sensorOptions = [
    { id: 'mfr', label: 'MFR Nodes' },
    { id: 'sap', label: 'Sap Flow' },
    { id: 'band', label: 'Band Dendrometer' },
    { id: 'wxt', label: 'WXT536 Weather' },
    { id: 'aqt', label: 'AQT530 Air Quality' }
  ];
  
  // Convert filter arrays to option objects for multi-select
  const statusValue = filters.status.map(id => statusOptions.find(opt => opt.id === id)).filter(Boolean);
  const cityValue = filters.city.map(id => cityOptions.find(opt => opt.id === id)).filter(Boolean);
  const sensorValue = filters.sensor.map(id => sensorOptions.find(opt => opt.id === id)).filter(Boolean);
  
  return (
    <div className="flex flex-wrap items-center gap-3 mt-4 mb-4">
      <div className="relative" style={{ width: 275 }}>
        <input
          aria-label="Search"
          placeholder="Search"
          className="border rounded-md px-3 py-2 text-sm w-full pl-9 h-10"
          value={filters.q}
          onChange={(e) => setFilters((f) => ({ ...f, q: e.target.value }))}
        />
        <span className="absolute left-2 top-2.5 text-gray-500">
          <svg width="20" height="20" viewBox="0 0 24 24" className="text-gray-500">
            <path
              fill="currentColor"
              d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zM9.5 14C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
            />
          </svg>
        </span>
      </div>
      
      <FilterMenu
        label="Status"
        options={statusOptions}
        value={statusValue}
        onChange={(newValue) => setFilters((f) => ({ ...f, status: newValue.map(v => v.id) }))}
        multiple={true}
        disableCloseOnSelect={true}
      />
      
      <FilterMenu
        label="City"
        options={cityOptions}
        value={cityValue}
        onChange={(newValue) => setFilters((f) => ({ ...f, city: newValue.map(v => v.id) }))}
        multiple={true}
        disableCloseOnSelect={true}
      />
      
      <FilterMenu
        label="Device"
        options={sensorOptions}
        value={sensorValue}
        onChange={(newValue) => setFilters((f) => ({ ...f, sensor: newValue.map(v => v.id) }))}
        multiple={true}
        disableCloseOnSelect={true}
      />
      
      <div className="ml-auto">
        <Tooltip title="Download CSV">
          <IconButton size="small" onClick={onDownload}>
            <CloudDownloadOutlinedIcon />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
}